import { render, staticRenderFns } from "./KiBitLogo.vue?vue&type=template&id=b4d185ae&"
import script from "./KiBitLogo.vue?vue&type=script&lang=js&"
export * from "./KiBitLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports